<div class="layout-sidebar " #sidebar (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
        <a [routerLink]="['/accueil']" class="logo">
            <div class="logo-image w-full" *ngIf="subSiteName">
                <img src="assets/layout/images/logo-{{subSiteName}}-White.svg" alt="diamond-layout" class="w-8rem" />
              </div>
              <div *ngIf="!subSiteName">
                  <img src="assets/layout/images/logo-{{ logo }}.svg" alt="diamond-layout" class="w-full max-w-7rem" />
              </div>
        <span class="app-name">TESSI</span>
    </a>
    <button class="layout-sidebar-anchor p-link" type="button" (click)="anchor()"></button>
  </div>

  <div #menuContainer class="layout-menu-container">
    <app-menu></app-menu>
  </div>
</div>
